import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useSuggestions } from 'bdvp-common/src/hooks';

import { Typeahead } from './TypeaheadInput.styles';

const TypeaheadInput = (props) => {

    const {
        selected,
        onChange,
        placeholder,
        typeaheadFieldId,
        suggestionsKey,
        excludeId,
        disabled,
    } = props;

    const [
        suggestionsValue,
        setSuggestionsValue,
    ] = useState('');

    const [
        searchValue,
        setSearchValue,
    ] = useState(selected?.label ?? '');

    useEffect(() => {

        setSearchValue(selected?.label ?? '');

    }, [
        selected?.label,
        setSearchValue,
    ]);

    const {
        suggestions,
        clearSuggestions,
    } = useSuggestions({
        value: suggestionsValue,
        queryParams: {
            fieldId: typeaheadFieldId,
        },
        suggestionKeys: [suggestionsKey],
        excludeSuggestions: [
            {
                suggestionsKey,
                ids: [excludeId],
            },
        ],
    });

    const onItemClickHandler = (event, info) => {

        const { value, displayName } = suggestions[info.index];
        const selectedItem = {
            value,
            label: displayName,
        };

        clearSuggestions();
        setSuggestionsValue('');
        setSearchValue(displayName);

        onChange({
            changes: selectedItem,
            selected: [selectedItem],
            event: 'select-option',
        });

    };

    const onChangeHandler = (event) => {

        const inputValue = event.target.value;
        const isInputEmpty = inputValue === '';

        if (isInputEmpty) {

            clearSuggestions();

        }

        setSuggestionsValue(inputValue);
        setSearchValue(inputValue);

        if(selected && selected?.label !== inputValue) {

            onChange({
                changes: selected,
                selected: [selected],
                event: 'deselect-option',
            });

        }

    };

    const onClearInputHandler = (event, shouldResetValue) => {

        clearSuggestions();

        if(selected && selected?.label === searchValue) {

            onChange({
                changes: selected,
                selected: [selected],
                event: 'deselect-option',
            });

        }

        if(shouldResetValue) {

            setSearchValue('');

        }

    };

    return (
        <Typeahead
            disabled={disabled}
            placeholder={placeholder}
            onItemClick={onItemClickHandler}
            suggestions={suggestions}
            value={searchValue}
            onChange={onChangeHandler}
            onClearInput={onClearInputHandler}
            shouldClearValueOnSelect={false}
            iconType={'search'}
        />
    );

};

TypeaheadInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    typeaheadFieldId: PropTypes.number.isRequired,
    suggestionsKey: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    selected: PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
    }),
    excludeId: PropTypes.string,
};

TypeaheadInput.defaultProps = {
    disabled: undefined,
    selected: undefined,
    excludeId: undefined,
};

export default TypeaheadInput;
